import { AsyncStatusEnum } from './common';

export enum AutoSuggestModelName {
  GPT3 = 'GPT3',
  GPTJ = 'GPTJ',
}

export interface BaseEditorAutoCompleteSourceData {
  id?: number;
  value: string;
  text?: string;
  icon?: string;
  modelName?: AutoSuggestModelName;
  preText?: string;
}

export interface Suggestions {
  allSuggestions: BaseEditorAutoCompleteSourceData[];
  selectedSuggestion: BaseEditorAutoCompleteSourceData | null;
  mTime?: number;
}

export interface SuggestionControls {
  isTooltipOpen: boolean;
  isSuggestionOpen: boolean;
  currentSuggestionIndex: number;
  suggestionsRemainingPerMinute: number;
  suggestionsRemainingPerHour: number;
}

export interface AutoSuggestState extends Suggestions {
  status: AsyncStatusEnum;
  currentElement: HTMLElement | null;
  controls: SuggestionControls;
}

// export type Suggestions = Omit<AutoSuggestState, 'controls'>;
// @TODO: Use Enums
export const SYSTEM_SUGGESTION_SHOWN = 'rshr/system/suggestion_shown';
export const SYSTEM_TOGGLE_WA_TOOLTIP = 'rshr/system/shown_wa_tooltip';
export const SYSTEM_UPDATE_SUGGESTION_COUNT = 'rshr/system/update_suggestion_count';
export const USER_SUGGESTION_TOGGLE = 'rshr/user/suggestion_toggle';
export const USER_SELECTED_SUGGESTION = 'rshr/user/selected_suggestion';
export const USER_CHANGED_SUGGESTION_INDEX = 'rshr/user/changed_suggestion_index';
export const USER_REQUESTED_SUGGESTION = 'rshr/user/requested_suggestion';
